<template>
  <button
    class="button-toggle"
    :data-off="!isTssOn"
    @click="handleClickButton"
  >
    <ToggleSwitch v-model="isTssOn" @update:modelValue="handleClickToggle" />
    {{ t('tss') }}
  </button>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import { storeToRefs } from 'pinia';

import ToggleSwitch from '@/components/shared/composite/ToggleSwitch.vue';
import { useMicrophoneStore } from '@/stores/microphone';
import { useToastStore } from '@/stores/toast';

const { t } = useI18n();
const toastStore = useToastStore();
const microphoneStore = useMicrophoneStore();
const { isTssOn } = storeToRefs(microphoneStore);

// 버튼 클릭 시
const handleClickButton = () => {
  handleClickToggle(!isTssOn.value);
};

// 토글 클릭 시
const handleClickToggle = (newVal: boolean) => {
  isTssOn.value = newVal;
  toastStore.info(t(newVal ? 'toast_tss_on' : 'toast_tss_off'), 'TSS');
};
</script>

<style scoped lang="scss"></style>
